import { Controller } from '@hotwired/stimulus'
import ProfileForm from '../backend/_profile_form'

export default class extends Controller {
  static values = {
    artist: Object
  }

  connect () {
    this.setupProfileForm()
  }

  setupProfileForm () {
    let profileForm = new ProfileForm(this.artistValue)
    profileForm.apply()
  }
}
